module.exports = __webpack_public_path__ + "img/5f4cf6c281f4513c0aa606648992d2c0.svg";